jQuery(function ( $ ) {

	ymaps.ready(init_map);
	var myMap,
	    map_point = (window.contact_map_point && window.contact_map_point !== '') ? window.contact_map_point : [56.29761256842605, 43.982387499999895],
	    map_dsc   = (window.contact_map_dsc && window.contact_map_dsc !== '') ? window.contact_map_dsc : 'Нижний Новгород, просп. Гагарина, 23, корп. 1';

	function init_map() {
		myMap = new ymaps.Map('contact_map', {
			center  : map_point,
			zoom    : 16,
			controls: ['zoomControl', 'fullscreenControl']
		}, {
			searchControlProvider: 'yandex#search',
			maxZoom              : 17
		});
		myMap.behaviors.disable(['scrollZoom']);

		myMap.geoObjects.add(new ymaps.Placemark(map_point, {
			balloonContent: map_dsc
		}, {
			preset   : 'islands#icon',
			iconColor: '#0095b6'
		}))
	}


	$('.contact_form').submit(function ( e ) {
		var form = $(this),
		    data = $(this).serialize() + '&action=send_contact_form';

		e.preventDefault();

		form.find('.js-cform-result').slideUp(200);

		$.ajax({
			type   : 'POST',
			data   : data,
			url    : window.theme.ajax_url,
			success: function ( res ) {
				var data = JSON.parse(res.data);

				if( data.error ) {
					form.find('.js-cform-result').empty().append(data.error).slideDown(200);
				}

				if( data.good ) {
					form.trigger('reset');
					form.find('.js-cform-result').empty().append(data.good).slideDown(200);
				}
			},
			error  : function ( error ) {
				console.log(error);
			}
		});

		return false;
	});


});